"use client";

import { useEffect, useRef, Suspense } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import * as fpixel from "@/lib/fpixel";

function FacebookPixelPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const initialLoad = useRef(true);

  useEffect(() => {
    if (initialLoad.current) {
      initialLoad.current = false;
      return;
    }
    if (pathname && typeof window.fbq === "function") {
      fpixel.pageview();
    }
  }, [pathname, searchParams]);

  return null;
}

export default function SuspendedFacebookPixelPageView() {
  return (
    <Suspense fallback={null}>
      <FacebookPixelPageView />
    </Suspense>
  );
}
